export default __webpack_public_path__ + "static/summit_stars_4_7-f852a90d0b019397a748d8c6b548ef6f.svg";